import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import {
    FaArrowLeft,
    FaUser,
    FaWifi,
    FaNetworkWired,
    FaMapPin,
    FaServer,
    faHashtag,
    FaHashtag,
    FaUserTie,
    FaStore,
} from "react-icons/fa6";
import { FaNetworkWired as FaNetIcon } from "react-icons/fa";

// Import komponen form Anda
import { InputDefault } from "../../../../components/forms/InputDefault";
import { BtnDefault } from "../../../../components/buttons/BtnDefault";
import { SelectProfile } from "../../../../components/forms/selects/SelectProfile";
import { SelectNas } from "../../../../components/forms/selects/SelectNas";
import { SelectPop } from "../../../../components/forms/selects/SelectPop";
import { SelectOdp } from "../../../../components/forms/selects/SelectOdp";

// Import Utilities Map
import { MapView } from "../../../../utilities/leftjs/MapView";
import { LocationSearch } from "../../../../utilities/leftjs/LocationSearch";
import { LocationPicker } from "../../../../utilities/leftjs/LocationPicker";
import { MapSelect } from "../../../../utilities/leftjs/MapSelect";
import { MapSelectCurrent } from "../../../../utilities/leftjs/MapSelectCurrent";
import { PppoePsbService } from "../../../../services/PppoePsbService";
import { SelectUser } from "../../../../components/forms/selects/SelectUser";
import { TextAreaDefault } from "../../../../components/forms/TextAreaDefault";

// ============================================
// MAIN COMPONENT: PppoePsbCreate
// ============================================
export const PppoePsbCreate = () => {
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(false);

    // Peta
    const [position, setPosition] = useState(null);
    const [locationDetail, setLocationDetail] = useState(null);

    // Mock Data untuk Select Mitra & Sales (Ganti dengan API asli nantinya)
    const mitraOptions = [
        { id: "R001", name: "Mitra A (Pusat)" },
        { id: "R002", name: "Mitra B (Cabang)" },
    ];
    const salesOptions = [
        { id: "S001", name: "Sales Budi" },
        { id: "S002", name: "Sales Siti" },
    ];

    const [data, setData] = useState({
        registration_date: "",
        instalation_plan: "",

        id_pel: "",
        name: "",
        phone_number: "",
        address_detail: "", // Akan terisi otomatis dari peta

        mitra_id: "",
        sales_id: "",

        wifi_ssid: "",
        wifi_password: "",

        profile_id: "",
        price: 0,
        discount: 0,
        instalation_cost: 0, // BARU: Biaya Pasang

        nas_id: "",
        pop_id: "",
        odp_id: "",

        latitude: "",
        longitude: "",
    });

    const [error, setError] = useState({});

    // Handler saat user mengklik Peta
    const handleMapSelect = (pos, detail) => {
        setPosition(pos);
        setLocationDetail(detail);

        // Update state data otomatis
        const fullAddress = detail?.displayName || detail?.address?.road || "";
        setData((prev) => ({
            ...prev,
            latitude: pos.lat,
            longitude: pos.lng,
            address_detail: fullAddress
        }));
    };

    // Handler saat user mengetik koordinat manual
    const handleManualCoordChange = (field, value) => {
        setData((prev) => ({ ...prev, [field]: value }));

        // Update marker peta jika kedua koordinat valid
        const lat = field === 'latitude' ? value : data.latitude;
        const lng = field === 'longitude' ? value : data.longitude;

        if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
            setPosition({ lat: parseFloat(lat), lng: parseFloat(lng) });
            // Reset detail alamat jika koordinat berubah drastis manual (opsional)
            setLocationDetail(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const newError = {};
        let hasError = false;

        // Validation
        if (!data.name) { newError.name = "Nama tidak boleh kosong"; hasError = true; }
        else if (data.phone_number && (data.phone_number.length < 10 || data.phone_number.length > 13)) {
            newError.phone_number = "Nomor telepon harus 10 - 13 digit"; hasError = true;
        }
        else if (!data.address_detail) { newError.address_detail = "Alamat tidak boleh kosong"; hasError = true; }
        else if (!data.latitude || !data.longitude) {
            newError.latitude = "Titik lokasi (Koordinat) wajib ditentukan"; hasError = true;
        }
        else if (!data.profile_id) { newError.profile_id = "Paket wajib dipilih"; hasError = true; }
        else if (!data.nas_id) { newError.nas_id = "NAS wajib dipilih"; hasError = true; }
        else if (!data.pop_id) { newError.pop_id = "POP wajib dipilih"; hasError = true; }
        else if (!data.odp_id) { newError.odp_id = "ODP wajib dipilih"; hasError = true; }

        setError(newError);

        if (hasError) {
            setLoading(false);
            return;
        }

        try {
            const payload = {
                ...data,
                latitude: parseFloat(data.latitude),
                longitude: parseFloat(data.longitude),
                instalation_cost: parseFloat(data.instalation_cost),
                price: parseFloat(data.price),
                discount: parseFloat(data.discount),
            };
            await PppoePsbService.create({ data: payload });
            navigate(-1);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    };

    // Hitung Total Biaya Awal (Pasang + Paket Pertama - Diskon)
    // Atau tergantung kebijakan bisnis. Di sini saya asumsikan Total Tagihan Awal.
    const totalInitialCost = (data.price + data.instalation_cost) - data.discount;

    return (
        <>
            <Helmet>
                <title>Tambah PSB Baru - DANELA NET</title>
            </Helmet>

            <div>
                <header className="h-16 bg-slate-900/80 backdrop-blur-md border-b border-slate-700/50 sticky top-0 z-30 flex items-center justify-between px-4 lg:px-6">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => setShowSidebar(true)}
                            className="lg:hidden p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg"
                        >
                            <span className="text-xl">☰</span>
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm font-medium"
                        >
                            <FaArrowLeft />
                            <span className="hidden sm:inline">Kembali</span>
                        </button>
                        <h2 className="text-lg font-bold text-slate-100">Tambah Data PSB Baru</h2>
                    </div>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 disabled:text-slate-500 text-white text-sm font-medium px-4 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-lg shadow-cyan-900/20"
                    >
                        {loading ? "Menyimpan..." : "Simpan Data"}
                    </button>
                </header>

                <div className="p-4 lg:p-6 space-y-6">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                        {/* COLUMN 1: Data Pelanggan & Tim */}
                        <div className="rounded-2xl bg-slate-900/60 border border-slate-700/50 backdrop-blur-sm flex flex-col">
                            <div className="p-5 border-b border-slate-700/50">
                                <h3 className="text-sm font-semibold text-slate-300 flex items-center gap-2">
                                    <FaUser className="text-cyan-500" /> Data Pelanggan
                                </h3>
                            </div>
                            <div className="p-5 space-y-4">
                                <InputDefault
                                    id="idPel"
                                    label="ID Pelanggan"
                                    type="text"
                                    placeholder="Contoh: PLG001"
                                    value={data.id_pel}
                                    onChange={(e) => setData({ ...data, id_pel: e.target.value })}
                                    error={error.id_pel}
                                />
                                <InputDefault
                                    id="nik"
                                    label="NIK (opsional)"
                                    type="text"
                                    placeholder="masukan nik"
                                    value={data.id_pel}
                                    onChange={(e) => setData({ ...data, nik: e.target.value })}
                                    error={error.nik}
                                />
                                <InputDefault
                                    id="name"
                                    label="Nama Lengkap"
                                    type="text"
                                    placeholder="Nama pelanggan"
                                    value={data.name}
                                    onChange={(e) => setData({ ...data, name: e.target.value })}
                                    error={error.name}
                                />
                                <InputDefault
                                    id="phone_number"
                                    label="No. Telepon / WA"
                                    type="number"
                                    placeholder="08xxxxxxxxxx"
                                    value={data.phone_number}
                                    onChange={(e) => setData({ ...data, phone_number: e.target.value })}
                                    error={error.phone_number}
                                />

                                {/* Select Mitra & Sales */}
                                <SelectUser
                                    label={"Mitra (opsional)"}
                                    value={data.mitra_id}
                                    setValue={(id) => setData((prev) => ({ ...prev, mitra_id: id }))}
                                    error={error.mitra_id}
                                />

                                <SelectUser
                                    label={"Sales (opsional)"}
                                    value={data.sales_id}
                                    setValue={(id) => setData((prev) => ({ ...prev, sales_id: id }))}
                                    error={error.sales_id}
                                />

                                <TextAreaDefault
                                    id="address_detail"
                                    label="Alamat Lengkap"
                                    type="text"
                                    placeholder="Otomatis terisi dari peta"
                                    value={data.address_detail}
                                    onChange={(e) => setData({ ...data, address_detail: e.target.value })}
                                    error={error.address_detail}
                                    helperText="Klik pada peta untuk mengisi alamat otomatis"
                                />
                            </div>
                        </div>

                        {/* COLUMN 2: Paket & Biaya */}
                        <div className="rounded-2xl bg-slate-900/60 border border-slate-700/50 backdrop-blur-sm flex flex-col">
                            <div className="p-5 border-b border-slate-700/50">
                                <h3 className="text-sm font-semibold text-slate-300 flex items-center gap-2">
                                    <FaWifi className="text-cyan-500" /> Paket & Biaya
                                </h3>
                            </div>
                            <div className="p-5 space-y-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    <SelectProfile
                                        label={"Pilih Paket / Profile"}
                                        value={data.profile_id}
                                        setValue={(id) => setData((prev) => ({ ...prev, profile_id: id }))}
                                        setPrice={(price) => setData((prev) => ({ ...prev, price: price }))}
                                        error={error.profile_id}
                                    />

                                    <InputDefault
                                        id="price"
                                        label="Harga Paket (Bulanan)"
                                        type="number"
                                        value={data.price}
                                        disabled={true}
                                        className="bg-slate-800/50"
                                    />

                                    {/* BARU: Biaya Pasang */}
                                    <InputDefault
                                        id="instalation_cost"
                                        label="Biaya Pasang (Sekali Bayar)"
                                        type="number"
                                        placeholder="0"
                                        value={data.instalation_cost}
                                        onChange={(e) => setData({ ...data, instalation_cost: e.target.value })}
                                    />

                                    <InputDefault
                                        id="discount"
                                        label="Diskon"
                                        type="number"
                                        placeholder="0"
                                        value={data.discount}
                                        onChange={(e) => setData({ ...data, discount: e.target.value })}
                                    />
                                </div>

                                <div className="p-4 rounded-xl bg-slate-800/40 border border-slate-700/30 flex flex-col gap-2">
                                    <div className="flex justify-between text-xs text-slate-400">
                                        <span>Total Tagihan Awal</span>
                                        <span className="text-slate-500">(Paket + Pasang - Diskon)</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm font-medium text-slate-300">Estimasi Total</span>
                                        <span className="text-lg font-bold text-cyan-400">
                                            Rp {new Intl.NumberFormat('id-ID').format(totalInitialCost)}
                                        </span>
                                    </div>
                                </div>

                                <div className="my-2 border-t border-slate-700/30" />

                                <InputDefault
                                    id="pppoe_username"
                                    label="Username PPPoE"
                                    type="text"
                                    placeholder="Nama Pengguna"
                                    value={data.pppoe_username}
                                    onChange={(e) => setData({ ...data, pppoe_username: e.target.value })}
                                    error={error.pppoe_username}
                                />

                                <InputDefault
                                    id="pppoe_password"
                                    label="Password PPPoE"
                                    type="text"
                                    placeholder="Minimal 8 karakter"
                                    value={data.pppoe_password}
                                    onChange={(e) => setData({ ...data, pppoe_password: e.target.value })}
                                    error={error.pppoe_password}
                                />

                                <div className="my-2 border-t border-slate-700/30" />

                                <InputDefault
                                    id="wifi_ssid"
                                    label="SSID WiFi"
                                    type="text"
                                    placeholder="Nama WiFi"
                                    value={data.wifi_ssid}
                                    onChange={(e) => setData({ ...data, wifi_ssid: e.target.value })}
                                    error={error.wifi_ssid}
                                />

                                <InputDefault
                                    id="wifi_password"
                                    label="Password WiFi"
                                    type="text"
                                    placeholder="Minimal 8 karakter"
                                    value={data.wifi_password}
                                    onChange={(e) => setData({ ...data, wifi_password: e.target.value })}
                                    error={error.wifi_password}
                                />
                            </div>
                        </div>

                        {/* COLUMN 3: Jalur Jaringan */}
                        <div className="rounded-2xl bg-slate-900/60 border border-slate-700/50 backdrop-blur-sm flex flex-col">
                            <div className="p-5 border-b border-slate-700/50">
                                <h3 className="text-sm font-semibold text-slate-300 flex items-center gap-2">
                                    <FaNetworkWired className="text-cyan-500" /> Infrastruktur
                                </h3>
                            </div>
                            <div className="p-5 space-y-4">
                                <InputDefault
                                    id="registration_date"
                                    label="Tanggal Registrasi"
                                    type="date"
                                    value={data.registration_date}
                                    onChange={(e) => setData({ ...data, registration_date: e.target.value })}
                                />
                                <InputDefault
                                    id="instalation_plan"
                                    label="Rencana Instalasi"
                                    type="date"
                                    value={data.instalation_plan}
                                    onChange={(e) => setData({ ...data, instalation_plan: e.target.value })}
                                />

                                <SelectNas
                                    label={"Pilih NAS"}
                                    value={data.nas_id}
                                    setValue={(id) => setData((prev) => ({ ...prev, nas_id: id }))}
                                    error={error.nas_id}
                                />
                                <SelectPop
                                    label={"Pilih POP"}
                                    nas_id={data.nas_id}
                                    value={data.pop_id}
                                    setValue={(id) => setData((prev) => ({ ...prev, pop_id: id }))}
                                    error={error.pop_id}
                                />
                                <SelectOdp
                                    label={"Pilih ODP"}
                                    pop_id={data.pop_id}
                                    value={data.odp_id}
                                    setValue={(id) => setData((prev) => ({ ...prev, odp_id: id }))}
                                    error={error.odp_id}
                                />
                            </div>
                        </div>

                    </div>

                    {/* MAP SECTION */}
                    <div className="rounded-2xl bg-slate-900/60 border border-slate-700/50 backdrop-blur-sm overflow-hidden">
                        <div className="p-5 border-b border-slate-700/50 flex justify-between items-center">
                            <h3 className="text-sm font-semibold text-slate-300 flex items-center gap-2">
                                <FaMapPin className="text-cyan-500" /> Titik Lokasi & Koordinat
                            </h3>
                            {position && (
                                <span className="text-xs bg-emerald-500/10 text-emerald-400 px-2 py-1 rounded border border-emerald-500/20">
                                    Koordinat Terkunci
                                </span>
                            )}
                        </div>

                        <div className="p-5 grid grid-cols-1 lg:grid-cols-3 gap-6">
                            {/* Peta */}
                            <div className="lg:col-span-2 aspect-video lg:aspect-auto lg:h-96 rounded-xl overflow-hidden border border-slate-700/50 relative bg-slate-800">
                                <MapView>
                                    <LocationSearch setPosition={setPosition} />
                                    {/* Ubah LocationPicker agar menggunakan handler kita */}
                                    <LocationPicker
                                        setPosition={(pos) => {
                                            // Logic sederhana reverse geocode mock
                                            setPosition(pos);
                                            setData(prev => ({
                                                ...prev,
                                                latitude: pos.lat,
                                                longitude: pos.lng
                                            }));
                                            // locationDetail harus diambil dari library map Anda jika tersedia
                                        }}
                                    />
                                    {position && <MapSelect position={position} popup="Lokasi Pelanggan" />}
                                    <MapSelectCurrent
                                        position={position}
                                        setPosition={setPosition}
                                        popup="Lokasi Saya"
                                    />
                                </MapView>
                            </div>

                            {/* Detail & Manual Input */}
                            <div className="space-y-4">
                                {/* Input Manual Koordinat */}
                                <div className="bg-slate-800/50 rounded-xl p-4 border border-slate-700/50">
                                    <h4 className="text-xs font-bold text-slate-400 uppercase mb-3 flex items-center gap-2">
                                        <FaMapPin /> Input Koordinat Manual
                                    </h4>
                                    <div className="grid grid-cols-2 gap-3">
                                        <div>
                                            <label className="text-[10px] text-slate-500 mb-1 block">Latitude</label>
                                            <input
                                                type="number"
                                                step="any"
                                                className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-xs rounded px-2 py-1.5 focus:border-cyan-500 outline-none"
                                                placeholder="-6.2088"
                                                value={data.latitude}
                                                onChange={(e) => handleManualCoordChange('latitude', e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="text-[10px] text-slate-500 mb-1 block">Longitude</label>
                                            <input
                                                type="number"
                                                step="any"
                                                className="w-full bg-slate-900 border border-slate-600 text-slate-200 text-xs rounded px-2 py-1.5 focus:border-cyan-500 outline-none"
                                                placeholder="106.8456"
                                                value={data.longitude}
                                                onChange={(e) => handleManualCoordChange('longitude', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {error.latitude && <p className="text-[10px] text-red-400 mt-1">{error.latitude}</p>}
                                </div>

                                {/* Info Alamat (Jika ada dari map) */}
                                <div className="bg-slate-800/50 rounded-xl p-4 border border-slate-700/50">
                                    <h4 className="text-xs font-bold text-slate-400 uppercase mb-3">Info Lokasi Terpilih</h4>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between">
                                            <span className="text-slate-500">Jalan</span>
                                            <span className="text-slate-300 text-right max-w-[150px] truncate" title={locationDetail?.address?.road || data.address_detail}>
                                                {locationDetail?.address?.road || data.address_detail || "-"}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-slate-500">Kota</span>
                                            <span className="text-slate-300">{locationDetail?.address?.city || "-"}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-slate-500">Provinsi</span>
                                            <span className="text-slate-300">{locationDetail?.address?.state || "-"}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};